import React, { ReactNode } from 'react';

import cn from 'classnames';

import Button from '@/components/Button';
import { WizardStep } from '@/components/Wizard';
import { appUiIds } from '@/constants/appUiIds';
import useAppUiData from '@/hooks/useAppUiData';

import RichUI from '@/ui-kit/rich-text/RichUI/RichUI';

import styles from './ClaimBookingStep.module.scss';

type LayoutMessages = {
  title: string;
  subtitle: string;
  description: string;
};

type ClaimBookingSuccessLayoutProps = {
  tabId: string;
  messages: LayoutMessages;
  children: ReactNode;
  onSubmit: () => void;
  onCancel: () => void;
  isSubmitDisabled?: boolean;
};

const ClaimBookingSuccessLayout = ({
  tabId,
  messages,
  children,
  onSubmit,
  onCancel,
  isSubmitDisabled = false,
}: ClaimBookingSuccessLayoutProps) => {
  const appUi = useAppUiData();
  const { claimBooking: cab, commonLabels } = appUiIds;

  return (
    <WizardStep tabId={tabId}>
      <div className={cn(styles.successContainer, styles.successContainerMd)}>
        <h2 className={styles.title}>
          <RichUI code={messages.title} useRichText={false} />
        </h2>
        <p className={styles.sailorDetailsTitle}>{messages.subtitle}</p>

        <div className={cn(styles.selectForm, styles.selectFormMd)}>
          <p className={cn(styles.subtitle, styles.isBold)}>{messages.description}</p>

          {children}
        </div>
      </div>

      <div className={styles.buttonContainer}>
        <Button className={styles.gotoBtn} variant="primary" onClick={onSubmit} disabled={isSubmitDisabled}>
          {appUi[cab.next]}
        </Button>
        <Button onClick={onCancel} className={styles.cancelLink}>
          {appUi[commonLabels.cancel]}
        </Button>
      </div>
    </WizardStep>
  );
};

export default ClaimBookingSuccessLayout;
export type { LayoutMessages };
